<template>
  <div class="p-postEditor__itemWrapper">
    <post-gallary
      :post-gallary="postGallary"
      @close-post-gallary="postGallary = false"
      @select-post="updatePost"
    />
    <div v-if="editingItemIndex !== index" @click="editItem">
      <item-preview :item="item" />
    </div>
    <item-form v-if="editingItemIndex === index" :item="item">
      <div v-if="targetPost">
        <v-card
          tile
          outlined
          @mouseover="overlay = true"
          @mouseleave="overlay = false"
        >
          <v-container fluid class="pa-2">
            <v-row>
              <v-col lg="2">
                <v-avatar class="profile" size="100" tile>
                  <v-img :src="eyecatchableSrc(targetPost)" />
                </v-avatar>
              </v-col>
              <v-col lg="10">
                <div class="subtitle-2 pb-2">
                  {{ targetPost.title }}
                </div>
                <p class="caption">
                  {{ targetPost.introduction }}
                </p>
              </v-col>
            </v-row>
          </v-container>
          <v-overlay :value="overlay" absolute>
            <input type="hidden" autofocus />
            <v-btn color="primary" @click.stop="postGallary = true">
              記事を変更する
            </v-btn>
          </v-overlay>
        </v-card>
      </div>
      <div v-else class="pt-5 text-center">
        <v-btn
          id="p-postEditor_focus"
          color="primary"
          @click.stop="postGallary = true"
        >
          関連記事を選択する
        </v-btn>
      </div>
    </item-form>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import PostGallary from '@/components/commons/PostGallary'

export default {
  name: 'InternalLinkItem',
  components: {
    PostGallary
  },
  mixins: [itemUtilsMixin],
  data: () => {
    return {
      postGallary: false,
      overlay: false
    }
  },
  computed: {
    targetPost: function () {
      return this.editingItemable.targetPost
    },
    eyecatchableSrc () {
      return function (post) {
        if (post.eyecatchable) {
          return post.eyecatchable.file.middle.url
        } else {
          return 'http://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image'
        }
      }
    }
  },
  mounted: function () {
    if (this.item.itemableAttributes.targetPostId) {
      const query = {
        postId: this.item.itemableAttributes.targetPostId,
        itemUuid: this.item.uuid
      }
      this.$store.dispatch('PostEditor/fetchTargetPost', query)
    }
    const element = document.getElementById('p-postEditor_focus')
    if (element) {
      element.focus()
    }
  },
  methods: {
    updatePost (post) {
      let itemable = { ...this.editingItemable }
      itemable.targetPost = post
      itemable.targetPostId = post.id
      this.$store.commit('PostEditor/UPDATE_EDITING_ITEMABLE', itemable)
    }
  }
}
</script>

<style scoped></style>
